import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { userDetailLoad } from "store/models/user";
import { DetailLoadComponent } from 'components/common';


const UserValue = (props) => {
  return (
    <DetailLoadComponent
      apiLoad={userDetailLoad}
      {...props}
      getDetailUrl={(id, item) => props.model.urls.detail(id)}
      render={({ id, item, linkPath }) => {
        const value = (item && item.email) || id;

        return (
          <Fragment>
            {props.asLink && linkPath ?
              <Link to={linkPath}>{value}</Link> :
              <span>{value}</span>}
          </Fragment>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.user,
});

export default connect(mapState)(UserValue);
